import {$get} from "../../core/js/Ajax.ts";
import {$, createElement, empty, html_chargement_en_cours} from "../../core/js/Dom.ts";
import {updateDateFinPlus4An} from "../../core/js/Utils.ts";
import {date_picker_init} from "../../core/js/DatePicker.ts";

export function ajouterLiensPageAide(url: string, pk: string, parent: Element|null, cible: Element|null = null) {
    if(parent) {
        const options: any = {
            pk: pk,
        }
        $get(url, options).then((data) => {
            if (data.body) {
                if(cible) {
                    empty(cible)
                    cible.append(html_chargement_en_cours())
                    $get(data.body, {embed: true}).then(response => cible.innerHTML = response.body)
                } else {
                    const div = createElement('div', ['fr-text--sm', 'fr-grid-row', 'fr-grid-row--right', 'w-full', 'page-aide'])
                    const element = createElement('a', ['fr-link'])
                    element.href = data.body
                    element.target = '_blank'
                    element.innerText = "Consulter la page d'aide dédiée à cette discipline"
                    div.appendChild(element)
                    const existant = $('.page-aide', parent)
                    if (existant) existant.remove()
                    parent?.appendChild(div);
                }
            }
        });
    }
}

export function setCloneFormState() {
    const dateDeFin = $<HTMLInputElement>('#id_date_fin')
    const dateDedebut = $<HTMLInputElement>('#id_date_debut')
    const estUneHomologation = $('[data-dossier-type]')?.getAttribute('data-dossier-type')?.includes('homologation') ?? false
    // il faut disable l'element avant de l'initialiser avec flatpicker sinon il est modifiable
    if(dateDeFin && dateDedebut && estUneHomologation)
    {
        // impossibilité de modifier la date de fin d'homologation dans le cas d'une homologation de circuit
        dateDeFin.setAttribute('disabled', 'true')
        dateDeFin.style.cursor = "not-allowed"
    }
    date_picker_init();
    if(dateDeFin && dateDedebut && estUneHomologation) {
        // on enleve le disabled et on met readonly pour recuperer la valeur lors de la requete
        dateDeFin.removeAttribute('disabled')
        dateDeFin.setAttribute('readonly', 'true')
        dateDeFin.style.cursor = "not-allowed"
        // mettre à jour la date de fin d'homologation en fonction de la date de début
        // @ts-ignore
        dateDedebut?._flatpickr.config.onChange.push(() => {
            updateDateFinPlus4An(dateDedebut, dateDeFin)
        });
    }
}